import { createContext, useReducer } from "react"

const reducer = (state, action) => {
  switch (action.type) {
    case "SET_LOGIN":
      return {
        ...state,
        ...action.payload,
      }

    case "SET_THEME":
      return {
        ...state,
        ...action.payload,
      }

    case "LOGOUT":
      return {
        ...state,
        jwt: null,
        usr: {
          name: null,
          img: null,
        },
      }

    default:
      return state
  }
}

const initialState = {
  theme: "dark",
  active: false,
  jwt: null,
  usr: {
    name: null,
    role: null,
    img: null,
  },
}

export const UserContext = createContext({
  state: initialState,
  dispatch: () => null,
})

export const UserProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  return (
    <UserContext.Provider value={[state, dispatch]}>
      {children}
    </UserContext.Provider>
  )
}

// export default UserContext;
